import PropTypes from "prop-types";
import {
  createContext,
  useEffect,
  useReducer,
  useCallback,
  useMemo,
} from "react";
// utils
import localStorageAvailable from "../utils/localStorageAvailable";
//
import { isValidToken, setSession } from "./utils";
import { apiAdminConfig } from "../utils/api";
import { useSnackbar } from "../provider/snackbar";

// ----------------------------------------------------------------------

// NOTE:
// We only build demo at basic level.
// Customer will need to do some extra handling yourself if you want to extend the logic and other features...

// ----------------------------------------------------------------------

const initialState = {
  isInitialized: false,
  isAuthenticated: false,
  user: null,
};

const reducer = (state, action) => {
  if (action.type === "INITIAL") {
    return {
      isInitialized: true,
      isAuthenticated: action.payload.isAuthenticated,
      user: action.payload.user,
    };
  }
  if (action.type === "LOGIN") {
    return {
      ...state,
      isAuthenticated: true,
      user: action.payload.user,
    };
  }
  if (action.type === "REGISTER") {
    return {
      ...state,
      isAuthenticated: true,
      user: action.payload.user,
    };
  }
  if (action.type === "LOGOUT") {
    return {
      ...state,
      isAuthenticated: false,
      user: null,
    };
  }

  return state;
};

// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const snackbar = useSnackbar();

  const storageAvailable = localStorageAvailable();

  const initialize = useCallback(async () => {
    try {
      const accessToken = storageAvailable
        ? localStorage.getItem("LogisticAdminToken")
        : "";

      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);

        const response = await apiAdminConfig.get("/api/auth/user-profile");

        const user = response.data;

        dispatch({
          type: "INITIAL",
          payload: {
            isAuthenticated: true,
            user,
          },
        });
      } else {
        dispatch({
          type: "INITIAL",
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    } catch (error) {
      console.error(error);
      dispatch({
        type: "INITIAL",
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });
    }
  }, [storageAvailable]);

  useEffect(() => {
    initialize();
  }, [initialize]);


  // LOGIN
  const login = useCallback(async (email, password) => {

    const response = await apiAdminConfig.post("/api/auth/login", {
    // const response = await apiAdminConfig.post("https://webpristine.com/work/clickandsend", {
      email,
      password,
    });
    if (response?.data) {
      const { access_token, user } = response?.data;
      console.log("response?.", response, access_token);
      setSession(access_token);
      snackbar({
        message: "Log in successfully",
        severity: "success",
      });

      dispatch({
        type: "LOGIN",
        payload: {
          user,
        },
      });
    }
  }, []);

  // REGISTER
  const register = useCallback(async (email, password, firstName, lastName) => {
    const response = await apiAdminConfig.post("/api/auth/register", {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    localStorage.setItem("LogisticAdminToken", accessToken);

    dispatch({
      type: "REGISTER",
      payload: {
        user,
      },
    });
  }, []);

  // LOGOUT
  const logout = useCallback(() => {
    setSession(null);
    dispatch({
      type: "LOGOUT",
    });
  }, []);

  const memoizedValue = useMemo(
    () => ({
      isInitialized: state.isInitialized,
      isAuthenticated: state.isAuthenticated,
      user: state.user,
      method: "jwt",
      login,
      register,
      logout,
    }),
    [
      state.isAuthenticated,
      state.isInitialized,
      state.user,
      login,
      logout,
      register,
    ]
  );

  return (
    <AuthContext.Provider value={memoizedValue}>
      {children}
    </AuthContext.Provider>
  );
}





// import PropTypes from "prop-types";
// import {
//   createContext,
//   useEffect,
//   useReducer,
//   useCallback,
//   useMemo,
// } from "react";
// // utils
// import localStorageAvailable from "../utils/localStorageAvailable";
// //
// import { isValidToken, setSession } from "./utils";
// import { apiAdminConfig } from "../utils/api";
// import { useSnackbar } from "../provider/snackbar";

// // ----------------------------------------------------------------------

// // NOTE:
// // We only build demo at basic level.
// // Customer will need to do some extra handling yourself if you want to extend the logic and other features...

// // ----------------------------------------------------------------------

// const initialState = {
//   isInitialized: false,
//   isAuthenticated: false,
//   user: null,
// };

// const reducer = (state, action) => {
//   if (action.type === "INITIAL") {
//     return {
//       isInitialized: true,
//       isAuthenticated: action.payload.isAuthenticated,
//       user: action.payload.user,
//     };
//   }
//   if (action.type === "LOGIN") {
//     return {
//       ...state,
//       isAuthenticated: true,
//       user: action.payload.user,
//     };
//   }
//   if (action.type === "REGISTER") {
//     return {
//       ...state,
//       isAuthenticated: true,
//       user: action.payload.user,
//     };
//   }
//   if (action.type === "LOGOUT") {
//     return {
//       ...state,
//       isAuthenticated: false,
//       user: null,
//     };
//   }

//   return state;
// };

// // ----------------------------------------------------------------------

// export const AuthContext = createContext(null);

// // ----------------------------------------------------------------------

// AuthProvider.propTypes = {
//   children: PropTypes.node,
// };

// export function AuthProvider({ children }) {
//   const [state, dispatch] = useReducer(reducer, initialState);
//   const snackbar = useSnackbar();

//   const storageAvailable = localStorageAvailable();

//   const initialize = useCallback(async () => {
//     try {
//       const accessToken = storageAvailable
//         ? localStorage.getItem("LogisticAdminToken")
//         : "";

//       if (accessToken && isValidToken(accessToken)) {
//         setSession(accessToken);

//         const response = await apiAdminConfig.get("/api/auth/user-profile");

//         const user = response.data;

//         dispatch({
//           type: "INITIAL",
//           payload: {
//             isAuthenticated: true,
//             user,
//           },
//         });
//       } else {
//         dispatch({
//           type: "INITIAL",
//           payload: {
//             isAuthenticated: false,
//             user: null,
//           },
//         });
//       }
//     } catch (error) {
//       console.error(error);
//       dispatch({
//         type: "INITIAL",
//         payload: {
//           isAuthenticated: false,
//           user: null,
//         },
//       });
//     }
//   }, [storageAvailable]);

//   useEffect(() => {
//     initialize();
//   }, [initialize]);


//   // LOGIN
//   const login = useCallback(async (email, password) => {

//     // const response = await apiAdminConfig.post("/api/auth/login", {
//     const response = await apiAdminConfig.post("https://webpristine.com/work/clickandsend", {
//       email,
//       password,
//     });
//     if (response?.data) {
//       const { access_token, user } = response?.data;
//       console.log("response?.", response, access_token);
//       setSession(access_token);
//       snackbar({
//         message: "Log in successfully",
//         severity: "success",
//       });

//       dispatch({
//         type: "LOGIN",
//         payload: {
//           user,
//         },
//       });
//     }
//   }, []);

//   // REGISTER
//   const register = useCallback(async (email, password, firstName, lastName) => {
//     const response = await apiAdminConfig.post("/api/auth/register", {
//       email,
//       password,
//       firstName,
//       lastName,
//     });
//     const { accessToken, user } = response.data;

//     localStorage.setItem("LogisticAdminToken", accessToken);

//     dispatch({
//       type: "REGISTER",
//       payload: {
//         user,
//       },
//     });
//   }, []);

//   // LOGOUT
//   const logout = useCallback(() => {
//     setSession(null);
//     dispatch({
//       type: "LOGOUT",
//     });
//   }, []);

//   const memoizedValue = useMemo(
//     () => ({
//       isInitialized: state.isInitialized,
//       isAuthenticated: state.isAuthenticated,
//       user: state.user,
//       method: "jwt",
//       login,
//       register,
//       logout,
//     }),
//     [
//       state.isAuthenticated,
//       state.isInitialized,
//       state.user,
//       login,
//       logout,
//       register,
//     ]
//   );

//   return (
//     <AuthContext.Provider value={memoizedValue}>
//       {children}
//     </AuthContext.Provider>
//   );
// }
